import { goToNews } from '@/app/routing/events'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'

export const LoyaltyProgramNews = () => {
  const { classes } = useStyles()
  const lang = useUnit($userLanguage)
  const prefix = lang === 'en' ? 'en' : 'ru'

  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'loyalty' })}
    >
      <img src={`https://storage.yandexcloud.net/gamed/news/${prefix}loyalty.webp`} />
    </div>
  )
}
